import React, { Component, Dispatch } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
// actions
import { actions as authUserActions } from '../../store/reducers/authUser';
import { RouteKeys } from '../route-keys';
import User from '../../models/user';
// import { thisExpression } from '@babel/types';

interface CustomProps {
  component: any;
  isUserAuthenticated: () => boolean;
  redirectSave: (pathname: string) => void;
  exact?: boolean;
  path?: string;
  selectedLanguage?: string;
  user?: User;
}

class AuthenticateRoute extends Component<CustomProps> {
  render() {
    const {
      isUserAuthenticated,
      redirectSave,
      component,
      selectedLanguage,
      user,
      ...rest
    } = this.props;

    return (
      <Route
        {...rest}
        render={(props) => {
          // console.log('props location: ', props, props.location);
          if (!isUserAuthenticated()) {
            redirectSave(props.location.pathname);
          }
          if (isUserAuthenticated() && user?.isPreRegisteredUser && !user?.nationality) {
            return (
              <Redirect
                to={{
                  pathname: `/${selectedLanguage}${RouteKeys.QuickSignup}`,
                }}
                from={props.location.pathname}
              />
            );
          } else if(isUserAuthenticated() ){
            return <this.props.component {...props} />;
          }
          return (
            <Redirect
              to={{
                pathname: `/${selectedLanguage}${RouteKeys.Login}`,
              }}
              from={props.location.pathname}
            />
          );
        }}
      />
    );
  }
}

// AuthenticateRoute.propTypes = {
//   component: PropTypes.elementType.isRequired,
//   location: PropTypes.shape({
//     pathname: PropTypes.string.isRequired,
//   }).isRequired,
//   isUserAuthenticated: PropTypes.func.isRequired,
//   redirectSave: PropTypes.func,
// };

// AuthenticateRoute.defaultProps = {
//   redirectSave: () => {},
// };

const mapStateToProps = (state: any) => ({
  isUserAuthenticated: () => state.authUser.token != null,
  selectedLanguage: state.language.selectedLanguage,
  user: state.registration.user,
});

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({
  redirectSave: (to: string) => {
    dispatch(authUserActions.redirectSave(to));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticateRoute);
